import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=53db3ec4"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53db3ec4')) {
      api.createRecord('53db3ec4', component.options)
    } else {
      api.reload('53db3ec4', component.options)
    }
    module.hot.accept("./Btn.vue?vue&type=template&id=53db3ec4", function () {
      api.rerender('53db3ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/Btn.vue"
export default component.exports